// Dönüş parametreleri (?don=, ?back=) yalnızca site içi yol olabilir — dış adrese/şemaya yönlendirme engellenir
export const safePath = (p) => (typeof p === "string" && /^\/(?![/\\])/.test(p) ? p : null);
